var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigure02Shroom01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182.39 299.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fdfbef;}.cls-2{fill:#213043;}.cls-3{fill:#feb73b;}.cls-4{fill:#f789b6;}.cls-5{fill:#2b3044;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.25,55.81c-1.34-8.65-25.79-45.66-47-37.76-28,10.41-5.51,54.43,1.14,62.83S62.59,64.46,61.25,55.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20,83.09c-2.12,0-3.92-.52-5-1.9C10.61,75.68-4,49.23,1,31.4c1.86-6.65,6.24-11.3,13-13.82,5.87-2.18,12.4-1.21,19.39,2.89,15.11,8.86,27.4,29.34,28.31,35.27S46.66,73.57,32.82,79.62C29.33,81.14,24.08,83.09,20,83.09Zm.38-65.64a16.86,16.86,0,0,0-6,1.07C7.93,20.92,3.76,25.34,2,31.67c-4.88,17.46,9.47,43.48,13.76,48.9,2,2.56,8.1,1.88,16.67-1.87,14.51-6.34,29.07-18.06,28.34-22.81-.9-5.79-13-25.84-27.84-34.56A25.05,25.05,0,0,0,20.36,17.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.94,82.06c-1.92-.71-3.86-8.3,14.44-19.35,14-8.45,29.85-12.94,29.79-5.54S29.14,86.6,16.94,82.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.81,83.18a11.79,11.79,0,0,1-4-.65h0A2.75,2.75,0,0,1,15.28,80c-.22-2.33.88-8.72,15.84-17.75,10.54-6.37,23.77-11.35,28.67-8.56a3.72,3.72,0,0,1,1.88,3.46c0,3.88-7.52,10.4-13.91,14.8C39.69,77.54,28.6,83.18,20.81,83.18Zm-3.7-1.59c6.7,2.49,19.94-3.44,30.08-10.43,7.91-5.44,13.45-11.2,13.48-14a2.69,2.69,0,0,0-1.38-2.58c-4-2.26-15.85,1.41-27.65,8.54-14.88,9-15.52,15.14-15.37,16.81a1.93,1.93,0,0,0,.84,1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.9,61.81s20.82,34.55,34.73,92.28c14.94,62,21.06,127.59,23.29,135.23,1.23,4.2,8,6.51,10.17-7.46C104.4,260.58,82.73,185,71.53,146.44c-12.2-42-35-86.61-35-86.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.72,293.05a4.71,4.71,0,0,1-4.28-3.59c-.68-2.33-1.69-9.74-3.21-21C83.62,242,77.59,197.57,67.14,154.21c-13.72-57-34.46-91.8-34.67-92.14l-.27-.45,4.51-2.47.23.46c.23.44,23,45.15,35.07,86.69,15.37,52.87,32.62,116.06,29.58,135.64-1.51,9.72-5.15,11-6.64,11.1ZM33.59,62c2.47,4.25,21.6,38.32,34.53,92,10.46,43.42,16.49,87.85,20.1,114.4,1.46,10.77,2.52,18.55,3.18,20.81A3.66,3.66,0,0,0,94.89,292c2.6-.17,4.74-4,5.71-10.26,3.39-21.87-19.69-101.29-29.55-135.2C59.66,107.39,38.72,65.36,36.28,60.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.33,48.29S141.08,95.46,124.71,173c-14.1,66.75-26.21,109.9-24.45,118.6,1.16,5.72,7.62,2.82,12.1-14.34s12.89-56.61,22.3-109.2C144.91,110.72,152.1,47.92,152.1,47.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M102.56,294.77h-.07c-1.34,0-2.33-1.16-2.72-3.07-1.14-5.62,3.18-24.36,10.32-55.41,4-17.33,9-38.91,14.13-63.39C140.4,96.26,146.77,48.69,146.83,48.22l0-.4,5.79-.44-.07.6c-.07.63-7.31,63.47-17.45,120.16-10,55.74-18.25,93.69-22.31,109.25C109.49,290.23,105.22,294.77,102.56,294.77Zm45.21-246c-.65,4.77-7.17,51.41-22.58,124.34-5.17,24.5-10.13,46.08-14.12,63.42-6.87,29.85-11.41,49.58-10.32,55,.17.83.62,2.23,1.77,2.27h0c2.4,0,6.32-5.19,9.3-16.64,4.06-15.53,12.33-53.45,22.3-109.16,9.6-53.69,16.6-112.91,17.37-119.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.38,43.57C122,33.19,126.32,3.66,148.63.78c29.45-3.81,29.14,32.94,26.67,46S126.77,54,124.38,43.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.39,54.75c-14.12,0-31-4.68-32.5-11.07h0c-1.55-6.74-.4-21.66,7-32.3C135.37,5,141.31,1.22,148.57.28c8.3-1.08,14.94,1,19.72,6,10.37,11,8.93,33,7.5,40.54-.91,4.81-7.54,7.68-18.19,7.89ZM152.72,1a31.32,31.32,0,0,0-4,.27c-7,.9-12.68,4.5-17,10.68-7.23,10.39-8.36,24.94-6.85,31.51h0c1.39,6,19,10.55,32.71,10.28,10.13-.2,16.41-2.78,17.23-7.08,1.4-7.41,2.84-29-7.24-39.66C163.81,3,158.82,1,152.72,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.64,124.77s3.75,33.37,2.18,88.41c-1.36,47.37-6,78.09-1.65,84.16,2.88,4,10.35,1.75,11.78-10.46s2.33-40.2,1.25-77.49c-1.19-40.63-7.6-85-7.6-85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.62,299.65a4.67,4.67,0,0,1-3.85-2c-2.88-4-2-17.34-.67-39.46.76-12.31,1.72-27.63,2.22-45,1.55-54.36-2.14-88-2.18-88.34l-.06-.52,7-.47.06.46c.07.45,6.44,44.89,7.61,85.09,1.15,39.52,0,66.48-1.25,77.56-1,8.05-4.49,11.75-7.49,12.53A5.2,5.2,0,0,1,100.62,299.65ZM97.19,125.23c.46,4.46,3.58,37.19,2.13,88-.5,17.39-1.46,32.72-2.22,45-1.32,21.15-2.19,35.12.48,38.82a3.77,3.77,0,0,0,4.13,1.46c2.68-.7,5.86-4.14,6.74-11.68,1.3-11.05,2.4-37.95,1.25-77.42-1.11-37.95-6.85-79.69-7.53-84.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.07,131.6c-5.32-9-11.65-62,8.68-72.32,26.82-13.6,39.09,44.87,40.57,58.07S78.38,140.64,73.07,131.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.25,135.55c-5.66,0-10.1-1.12-11.61-3.69h0c-3.82-6.49-8.48-36.51-2.57-56.69,2.41-8.2,6.26-13.7,11.45-16.34,5.37-2.72,10.53-2.78,15.34-.18,17,9.14,24.9,49.22,26,58.65.59,5.26-5.94,10.7-17.47,14.54A70.79,70.79,0,0,1,84.25,135.55Zm5.33-77.8a16.69,16.69,0,0,0-7.6,2c-4.94,2.5-8.63,7.79-11,15.72-5.84,19.94-1.28,49.52,2.47,55.9h0c2.91,5,19,3.73,31.53-.46,11-3.68,17.33-8.72,16.79-13.48-1-9.33-8.86-48.94-25.43-57.88A14.13,14.13,0,0,0,89.58,57.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.34,163.7c.14-10.69,22.46-59.09,44.73-55.79,29.38,4.35,10,60.54,4.5,72.47S121.2,174.4,121.34,163.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.5,184.84a40.66,40.66,0,0,1-8.73-1.11c-14.54-3.27-32-12.94-31.93-20h0c.1-7.64,12.21-36.45,27.76-49.7,6.1-5.19,12-7.4,17.55-6.58a16.73,16.73,0,0,1,12.92,8.82c9.55,17.61-4.15,55.83-8,64.35C169.73,183.4,166.44,184.84,161.5,184.84Zm-39.66-21.13c-.08,6.46,17.06,15.87,31.15,19,9.18,2.07,15.42,1.13,17.12-2.58,3.86-8.43,17.44-46.21,8.08-63.45A15.75,15.75,0,0,0,166,108.41c-5.25-.78-10.88,1.36-16.75,6.36-15.36,13.07-27.31,41.43-27.41,48.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.16,182.24c1.81-1.4,2.69-11-17.09-18.92-15.1-6-31.55-6.82-30.46,2S157.62,191.16,169.16,182.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.94,185.25c-5.26,0-11.77-1.5-18.9-4.47-9.44-3.93-19.31-10.49-19.92-15.42a5.19,5.19,0,0,1,2-5.07c4.57-3.52,16.55-2.47,29.14,2.57,15.29,6.12,17.82,13.08,18.2,15.79.3,2.14-.35,3.48-1,4h0C167.2,184.39,163.93,185.25,159.94,185.25Zm-28.42-26c-3.44,0-6.17.61-7.79,1.86a4.24,4.24,0,0,0-1.62,4.15c.49,3.95,8.79,10.24,19.31,14.62,9.43,3.92,21.59,6.5,27.43,2h0c.38-.29.86-1.35.62-3.05-.35-2.54-2.78-9.08-17.58-15C144.43,160.81,137.06,159.23,131.52,159.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.16,163.77s-11.87,24.75-24,67.88c-10.46,37.13-13.59,62.33-19.3,65.73-3.75,2.23-10.35-1.72-8.69-11.61s7.73-31.86,18-60.43c11.21-31.15,28.36-63.66,28.36-63.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.6,298.48a6,6,0,0,1-3.39-1.1c-3.09-2.11-4.42-6.48-3.55-11.69,1.51-9,7.14-30.22,18-60.52,11.09-30.83,28.22-63.39,28.39-63.72l.21-.39,6.53,2.43-.23.49c-.12.25-12,25.22-24,67.8-3.84,13.62-6.72,25.77-9,35.54-4.17,17.6-6.69,28.22-10.48,30.49A4.94,4.94,0,0,1,107.6,298.48Zm40.18-136.17c-2,3.77-17.72,34.26-28.13,63.19-10.89,30.25-16.5,51.42-18,60.36-.81,4.81.36,8.81,3.12,10.7a4.49,4.49,0,0,0,4.82.39c3.44-2.05,6.06-13.11,10-29.86,2.32-9.78,5.21-21.95,9-35.58,11.09-39.38,22.09-63.75,23.81-67.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M152.3,40.29a2.15,2.15,0,0,1-.43,0c-3.09-.55-2.75-5.13-2.74-5.32l1,.08s-.28,3.87,1.91,4.26c1.88.33,2.74-3.52,2.75-3.56l1,.2C155.73,36.1,154.85,40.29,152.3,40.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.18,90.9c.31,3.21-1.34,6-3.69,6.3S77,95.08,76.66,91.87s1.34-6,3.69-6.29S84.86,87.69,85.18,90.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.13,97.72a4.07,4.07,0,0,1-2.58-1,7,7,0,0,1-2.39-4.83c-.34-3.47,1.51-6.54,4.13-6.84a4,4,0,0,1,3,.94,7,7,0,0,1,2.38,4.84h0c.35,3.47-1.5,6.54-4.12,6.84Zm-.42-11.66H80.4c-2.07.24-3.53,2.82-3.24,5.76a6.15,6.15,0,0,0,2,4.15,3,3,0,0,0,2.26.72c2.07-.23,3.53-2.81,3.24-5.75a6.19,6.19,0,0,0-2-4.15A3.11,3.11,0,0,0,80.71,86.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.16,85.51c.32,3.21-1.33,6-3.68,6.3S96,89.69,95.65,86.48s1.33-6,3.68-6.3S103.84,82.3,104.16,85.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.11,92.33a4.06,4.06,0,0,1-2.57-1,7.09,7.09,0,0,1-2.39-4.83c-.34-3.47,1.51-6.54,4.13-6.84a4,4,0,0,1,3,.94,7.09,7.09,0,0,1,2.39,4.83c.34,3.48-1.51,6.54-4.13,6.84A3,3,0,0,1,100.11,92.33Zm-.42-11.67-.3,0c-2.08.24-3.53,2.82-3.24,5.75a6.13,6.13,0,0,0,2,4.15,3,3,0,0,0,2.25.73c2.08-.24,3.53-2.82,3.24-5.75h0a6.13,6.13,0,0,0-2-4.15A3.08,3.08,0,0,0,99.69,80.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M83,91a2.49,2.49,0,0,1-1.61,3c-1.13.22-2.23-.77-2.47-2.21a2.5,2.5,0,0,1,1.61-3A2.35,2.35,0,0,1,83,91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M102,85a2.49,2.49,0,0,1-1.61,3A2.34,2.34,0,0,1,98,85.78a2.47,2.47,0,0,1,1.61-3A2.33,2.33,0,0,1,102,85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M94.79,110.1c-5,0-6.84-7.5-6.92-7.84l1-.23c0,.08,2,7.91,6.77,7C100,108.19,99,99.84,99,99.75l1-.11c0,.38,1,9.36-4.22,10.37A5.92,5.92,0,0,1,94.79,110.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 99.45,
    y: 77.83,
    width: 4.26,
    height: 1,
    transform: "translate(3.33 160.8) rotate(-77.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.55,28.15c-.53,2.34-2.35,3.88-4.07,3.43s-2.68-2.71-2.15-5.06,2.36-3.88,4.08-3.43S149.09,25.8,148.55,28.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.09,32.16a2.62,2.62,0,0,1-.73-.1c-2-.51-3.1-3.05-2.51-5.65a5.27,5.27,0,0,1,2.26-3.4,3.06,3.06,0,0,1,2.42-.41c2,.52,3.1,3.06,2.51,5.66h0a5.27,5.27,0,0,1-2.26,3.4A3.27,3.27,0,0,1,145.09,32.16Zm.71-8.65a2.27,2.27,0,0,0-1.17.35,4.38,4.38,0,0,0-1.81,2.77c-.47,2.08.33,4.09,1.79,4.47a2.11,2.11,0,0,0,1.65-.29A4.38,4.38,0,0,0,148.07,28h0c.47-2.08-.33-4.09-1.79-4.47A2,2,0,0,0,145.8,23.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.19,29.5c-.53,2.35-2.36,3.89-4.07,3.44s-2.69-2.72-2.15-5.06S159.32,24,161,24.44,163.72,27.16,163.19,29.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.73,33.52a3.07,3.07,0,0,1-.74-.1c-2-.52-3.1-3.05-2.51-5.65a5.3,5.3,0,0,1,2.26-3.41,3.1,3.1,0,0,1,2.42-.4c2,.52,3.1,3.05,2.51,5.66a5.27,5.27,0,0,1-2.26,3.4A3.24,3.24,0,0,1,159.73,33.52Zm.7-8.65a2.2,2.2,0,0,0-1.17.35A4.35,4.35,0,0,0,157.45,28c-.47,2.08.33,4.08,1.79,4.46a2.07,2.07,0,0,0,1.65-.29,4.35,4.35,0,0,0,1.81-2.77h0c.47-2.08-.33-4.08-1.79-4.46A2,2,0,0,0,160.43,24.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M147,27.61c-.17,1.08-1,1.83-1.84,1.67a1.85,1.85,0,0,1-1.21-2.23,1.76,1.76,0,0,1,1.83-1.67A1.86,1.86,0,0,1,147,27.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M161.81,28.57c-.17,1.08-1,1.83-1.83,1.67A1.85,1.85,0,0,1,158.76,28a1.76,1.76,0,0,1,1.84-1.67A1.85,1.85,0,0,1,161.81,28.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 161.49,
    y: 23.25,
    width: 3.13,
    height: 1,
    transform: "translate(58.44 151.06) rotate(-58.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 159.2,
    y: 21.97,
    width: 3.56,
    height: 1,
    transform: "translate(112.55 177.62) rotate(-80.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 97.93,
    y: 75.34,
    width: 1,
    height: 4.77,
    transform: "translate(-10.92 16.3) rotate(-8.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M97.47,81.65l-.86-.51.43.26-.46.16c-.13-.26-1.44-2.09-2.63-3.7l.8-.6C97.71,81.26,97.69,81.29,97.47,81.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 80.37,
    y: 83.34,
    width: 4.26,
    height: 1,
    transform: "translate(-17.04 146.49) rotate(-77.65)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 78.85,
    y: 80.84,
    width: 1,
    height: 4.77,
    transform: "translate(-12.01 13.39) rotate(-8.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M78.39,87.15l-.86-.5.43.25-.46.16c-.13-.26-1.44-2.09-2.63-3.7l.8-.59C78.63,86.76,78.6,86.8,78.39,87.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.37,39.35c.79,2.68,0,5.17-1.76,5.57S12.78,43.48,12,40.81s0-5.17,1.77-5.57S17.59,36.68,18.37,39.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.11,45.48c-1.87,0-3.81-1.86-4.6-4.53a6.24,6.24,0,0,1,.31-4.79,2.85,2.85,0,0,1,1.83-1.4c2-.47,4.33,1.49,5.2,4.45h0a6.24,6.24,0,0,1-.3,4.79,2.84,2.84,0,0,1-1.83,1.41A3.17,3.17,0,0,1,16.11,45.48Zm-1.86-9.79a1.58,1.58,0,0,0-.38,0,1.92,1.92,0,0,0-1.19.94,5.22,5.22,0,0,0-.21,4c.7,2.38,2.54,4.1,4,3.76a1.86,1.86,0,0,0,1.18-.93,5.27,5.27,0,0,0,.22-4C17.25,37.32,15.65,35.69,14.25,35.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.06,33.4c.79,2.67,0,5.16-1.76,5.57s-3.83-1.44-4.62-4.12,0-5.16,1.76-5.56S31.27,30.73,32.06,33.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.79,39.52c-1.87,0-3.8-1.85-4.59-4.52a6.24,6.24,0,0,1,.31-4.79,2.84,2.84,0,0,1,1.82-1.41c2.06-.47,4.34,1.49,5.21,4.46a6.2,6.2,0,0,1-.31,4.79,2.84,2.84,0,0,1-1.82,1.4A2.62,2.62,0,0,1,29.79,39.52Zm-1.85-9.79a1.58,1.58,0,0,0-.38.05,1.88,1.88,0,0,0-1.19.93,5.23,5.23,0,0,0-.21,4c.7,2.38,2.54,4.1,4,3.77a1.9,1.9,0,0,0,1.18-.94,5.22,5.22,0,0,0,.21-4h0C30.94,31.36,29.34,29.73,27.94,29.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16.93,41.1c.43,1.19.1,2.37-.73,2.64s-1.85-.49-2.27-1.68-.1-2.37.73-2.63S16.51,39.91,16.93,41.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.09,34.78c.43,1.19.1,2.37-.73,2.63s-1.84-.49-2.27-1.68-.1-2.37.73-2.63S30.67,33.59,31.09,34.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 28.36,
    y: 25.78,
    width: 1,
    height: 3.56,
    transform: "translate(-0.04 0.04) rotate(-0.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M159.46,25.06l-.64-.76.32.38-.49,0c0-.24-.53-1.86-1-3.3l1-.31C159.79,24.79,159.78,24.8,159.46,25.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 25.83,
    y: 25.22,
    width: 1,
    height: 4.13,
    transform: "translate(-7.56 10.28) rotate(-19.37)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 146.77,
    y: 21.95,
    width: 3.13,
    height: 1,
    transform: "translate(52.44 137.82) rotate(-58.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 144.47,
    y: 20.66,
    width: 3.56,
    height: 1,
    transform: "translate(101.52 162) rotate(-80.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M144.74,23.75l-.65-.76.33.38-.5,0c0-.23-.52-1.86-1-3.3l1-.3C145.06,23.48,145.05,23.49,144.74,23.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M25.45,30.72c-.14-.22-1.45-1.65-2.65-2.92l.73-.68c3,3.14,2.95,3.16,2.84,3.51l-1-.3.48.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 14.62,
    y: 31.84,
    width: 1,
    height: 3.56,
    transform: "translate(-0.04 0.02) rotate(-0.06)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 12.09,
    y: 31.28,
    width: 1,
    height: 4.13,
    transform: "translate(-10.34 6.06) rotate(-19.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M11.71,36.77c-.14-.21-1.46-1.65-2.65-2.92l.73-.68c3,3.14,2.94,3.16,2.84,3.51l-.48-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M29.33,47.24c1,2.11.69,4.37-.6,5s-3.12-.48-4.08-2.6-.69-4.37.6-5S28.37,45.13,29.33,47.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.45,138.18c-1.14,2.52-3.31,3.74-4.85,2.73s-1.85-3.88-.71-6.4,3.32-3.74,4.85-2.73S158.59,135.66,157.45,138.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.79,141.77a2.57,2.57,0,0,1-1.46-.45c-1.76-1.16-2.15-4.25-.89-7a5.66,5.66,0,0,1,3.28-3.25,2.68,2.68,0,0,1,2.3.32c1.76,1.16,2.14,4.24.89,7h0a5.7,5.7,0,0,1-3.29,3.25A2.71,2.71,0,0,1,153.79,141.77Zm1.77-9.85a1.87,1.87,0,0,0-.56.09,4.65,4.65,0,0,0-2.65,2.7c-1,2.26-.78,4.91.53,5.78a1.7,1.7,0,0,0,1.47.19A4.7,4.7,0,0,0,157,138h0c1-2.27.78-4.91-.53-5.78A1.68,1.68,0,0,0,155.56,131.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.18,144c-1.14,2.51-3.31,3.73-4.84,2.72s-1.85-3.88-.71-6.4,3.31-3.74,4.85-2.73S172.33,141.5,171.18,144Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.52,147.6a2.66,2.66,0,0,1-1.46-.44c-1.76-1.17-2.15-4.25-.89-7a5.68,5.68,0,0,1,3.29-3.25,2.66,2.66,0,0,1,2.29.32c1.76,1.16,2.15,4.25.89,7h0a5.71,5.71,0,0,1-3.28,3.26A3.15,3.15,0,0,1,167.52,147.6Zm1.77-9.85a1.87,1.87,0,0,0-.56.09,4.7,4.7,0,0,0-2.65,2.7c-1,2.27-.78,4.91.53,5.78a1.68,1.68,0,0,0,1.47.19,4.7,4.7,0,0,0,2.65-2.7c1-2.26.78-4.91-.53-5.78A1.65,1.65,0,0,0,169.29,137.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M156.07,137.11c-.46,1.18-1.45,1.79-2.22,1.37a2.38,2.38,0,0,1-.57-2.9c.45-1.18,1.45-1.79,2.22-1.37S156.52,135.93,156.07,137.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M170.11,142.55c-.45,1.18-1.45,1.79-2.21,1.37s-1-1.72-.58-2.9,1.45-1.79,2.22-1.37A2.38,2.38,0,0,1,170.11,142.55Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 171.28,
    y: 137.14,
    width: 3.87,
    height: 1,
    transform: "matrix(0.76, -0.65, 0.65, 0.76, -47.88, 145.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 168.89,
    y: 134.84,
    width: 4.12,
    height: 1,
    transform: "translate(-17.44 245.11) rotate(-68.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M168.36,138l-.61-.79.31.39-.5,0c0-.26-.28-2.26-.55-4l1-.16C168.67,137.71,168.66,137.73,168.36,138Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 157.5,
    y: 131.76,
    width: 4.17,
    height: 1,
    transform: "translate(-47.67 129.82) rotate(-38.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 155.05,
    y: 129.04,
    width: 4.12,
    height: 1,
    transform: "translate(-20.84 228.52) rotate(-68.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M154.48,132.38l-.33-.38-.49,0c0-.25-.41-2.23-.78-4l1-.21C154.78,132.13,154.76,132.14,154.48,132.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M159.53,151.73c-1,2.11-2.63,3.35-3.71,2.78s-1.18-2.75-.21-4.86,2.63-3.35,3.71-2.78S160.5,149.62,159.53,151.73Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigure02Shroom01);
export default __webpack_public_path__ + "static/media/figure_02_shroom_01.20fc8275b3ebd9df1fa2ba5837fb83ce.svg";
export { ForwardRef as ReactComponent };